import { ReactElement } from 'react';

import { cva, VariantProps } from 'class-variance-authority';

const styles = cva(
  'mb-6 mt-[82px] min-h-[190px] overflow-hidden bg-cover bg-center md:min-h-[230px]',
  {
    variants: {
      page: {
        'rede-credenciada': 'bg-rede-credenciada',
      },
    },
    defaultVariants: {
      page: 'rede-credenciada',
    },
  },
);

interface Props extends VariantProps<typeof styles> {
  title?: string;
  href?: string;
  mainText?: string;
}

export default function Banner({
  title,
  page = 'rede-credenciada',
  mainText,
}: Props): ReactElement {
  return (
    <section className={styles({ page })}>
      <div className="mx-auto flex min-h-[190px] max-w-7xl flex-col justify-end px-5 py-7 md:min-h-[230px]">
        {title && (
          <p className="mb-3 w-fit rounded bg-white/90 px-4 py-2 text-sm font-semibold uppercase text-primary-main shadow-card">
            {title}
          </p>
        )}
        <h1 className="max-w-3xl text-2xl font-semibold leading-snug text-neutral-white md:text-[2rem]">
          {mainText}
        </h1>
      </div>
    </section>
  );
}
